import React from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import LogoRed from '../../../assets/logo-red.png';

function LoadingModal() {
    return (
        <Backdrop open sx={{ zIndex: 1300, flexDirection: 'column', gap: 2, bgcolor: 'rgba(21,21,26,0.85)' }}>
            <Box component='img' src={LogoRed} alt='logo' sx={{ width: 56, height: 'auto', opacity: 0.9 }} />
            <CircularProgress sx={{ color: '#c0392b' }} size={32} />
        </Backdrop>
    );
}

export default LoadingModal;
